<template>
  <div>
    <box-header title="汽车充电站">
      <div class="box-header-tab">
        <div @click="changeType('year')" class="tab-item" :class="{'active': type === 'year'}">年视图</div>
        <div @click="changeType('month')" class="tab-item" :class="{'active': type === 'month'}">月视图</div>
        <div @click="changeType('beforeTen')" class="tab-item" :class="{'active': type === 'beforeTen'}">最近十日</div>
      </div>
    </box-header>
    <div class="box" style="height: 420px;background: rgba(7,17,32,.3);">
      <box-border line></box-border>
      <div class="box-filter">
        <div class="box-count">
          <span class="count-name">总量：</span>
          <span class="count-value">{{ count }}</span>
          <span class="count-unit">kwh</span>
        </div>

        <div v-if="type === 'year'" class="box-select">
          <el-select :value="currentYear" @change="changeYear" placeholder="请选择">
            <el-option
              v-for="(year,index) in yearList"
              :key="index"
              :value="year"
              :label="year + '年'"
            >
            </el-option>
          </el-select>
        </div>

        <div v-if="type === 'month'" class="box-select">
          <el-select :value="currentMonth" @change="changeMonth" placeholder="请选择">
            <el-option
              v-for="(month,index) in monthList"
              :key="index"
              :value="month"
              :label="month + '月'"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div style="height: calc(100% - 80px);background: rgba(10, 27, 46, .51);">
        <div id="chartXLTJ_Charge" class="chart"></div>
      </div>
    </div>

    <ModalXLTJ_Charge ref="ModalDetail" />
  </div>
</template>
<script>
import BoxHeader from "@/components/BoxHeader/BoxHeader.vue";
import BoxBorder from "@/components/BoxBorder/BoxBorder.vue";
import ModalXLTJ_Charge from "./ModalXLTJ_Charge.vue";

const yearMonthList = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
export default {
  name: "ChartXLTJ_Charge",
  components: { ModalXLTJ_Charge, BoxBorder, BoxHeader },
  data() {
    return {
      name: "充电站销量统计",
      type: "beforeTen",
      yearList: ["2023","2024","2025","2026"],
      currentYear: "",
      monthList: ["12","11","10","9","8","7","6","5", "4", "3", "2", "1"],
      currentMonth: "",
      data: [],
      sectionData: [],
      category: [],
      dateCateGory:[],
      max: 0,
      count: 0,
      totalCount:0
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.currentYear =  new Date().getFullYear() + "";
      this.chart = this.$echarts.init(document.getElementById("chartXLTJ_Charge"));
      this.bindEvents();
      this.getData();
    });
  },
  methods: {
    bindEvents() {
      this.chart.on("click", (data) => {
        if (this.type === "year") {
          return false;
        }
        if(this.type === "month") {
          let day = this.category[data.dataIndex];
          if (day) {
            day = parseInt(day);
          }
          const date = this.currentYear + '-' + this.$util.padStartInt(this.currentMonth,2) + '-' + this.$util.padStartInt(day,2);
          this.$refs.ModalDetail.open({date});
        }else{
          let date = this.dateCateGory[data.dataIndex];
          this.$refs.ModalDetail.open({date});
        }
      });
    },
    getData() {
      this.chart.showLoading({
        text: "加载中...",
        maskColor: "rgba(0,0,0,0)",
        fontSize: 26,
        fontWeight: "bold",
        fontFamily: "Alibaba PuHuiTi",
        textColor: "rgba(211, 238, 254, 1)",
      });
 /*     this.$api.getAllChargingPower().then(res=>{
        if(res.succeed){
          this.totalCount = res.data;
        }
      })
      this.$api.getData_XLTJ_Charge_Year(this.currentYear).then(res => {
          let data = res.data.map(item => item.dl);
          this.count = this.$lodash.sum(data).toFixed(2);
      });*/

      if (this.type === "year") {
        this.$api.getData_XLTJ_Charge_Year(this.currentYear)
            .then(res => {
              this.disposeData(res.data);
            });
      }

      if (this.type === "month") {
          this.$api.getData_XLTJ_Charge_Month(this.currentYear,this.currentMonth).then(res => {
              this.disposeData(res.data);
          });
      }
      //最近10日的数据
      if(this.type === "beforeTen"){
        const today = new Date();
        const formattedToday = today.toISOString().split('T')[0];
        const tenDaysAgo = new Date();
        tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
        const formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0];
        this.$api.getData_XLTJ_Charge_Month_Date_Range({begin: formattedTenDaysAgo,end:formattedToday}).then(res => {
          this.disposeData(res.data);
        });
      }
    },
    disposeData(sourceData) {
      if(this.type === 'beforeTen'){
        sourceData.sort((a, b) => new Date(a.date) - new Date(b.date));
        let dateList = sourceData.map(item=>item.date);
        this.data = sourceData.map(item => item.dl);
        this.sectionData = this.data.map(item => item + 90);
        let result = sourceData.map(item => {
          let day = item.date.split('-')[2];
          if(day.startsWith("0")){
            day = day.replace("0","");
          }
          return `${day}日`;
        });
        this.dateCateGory = dateList;
        this.category = result;
        this.max = this.$util.formatInt(this.$lodash.max(this.data) + 1000, 3);
      }else{
        this.data = sourceData.map(item => item.dl);
        this.sectionData = this.data.map(item => item + 90);
        if (this.type === "year") {
          this.category = yearMonthList;
          if (this.data.length < 12) {
            for (let i = 0; i < 12; i++) {
              if (!this.data[i]) this.data.push(0);
            }
          }
          this.max = this.$util.formatInt(this.$lodash.max(this.data) + 20000, 5);
        } else {
          this.category = sourceData.map(item => item.day + "日");
          this.max = this.$util.formatInt(this.$lodash.max(this.data) + 1000, 3);
        }
      }
      this.count = this.$lodash.sum(this.data).toFixed(2);
      this.renderChart();
    },
    renderChart() {
      this.chart.hideLoading();
      const barWidth = 30;
      const colorArr = ["#488BE1", "#53BAF4", "#67F0FE"];
      const color = {
        type: "linear",
        x: 0,
        x2: 1,
        y: 0,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: colorArr[0],
          },
          {
            offset: 0.5,
            color: colorArr[0],
          },
          {
            offset: 0.5,
            color: colorArr[1],
          },
          {
            offset: 1,
            color: colorArr[1],
          },
        ],
      };

      let options = {
        tooltip: {
          show: true,
          trigger: "axis",
          confine: true,
          className: "echarts-tooltip",
          extraCssText: "padding: 20px 30px",
          formatter: "<div class='title'>{a0}</div><div class='name'>{b0}</div><div class='value'>{c0}<span class='unit'>kwh</span></div>",
          textStyle: {
            fontSize: 30,
          },
        },
        grid: {
          top: 45,
          bottom: 30,
          left: 30,
          right: 50,
          containLabel: true,
        },
        dataZoom: [{
          type: "inside",
          show: true,
          startValue: 0,
          endValue: 11,
          rangeMode: ["value"],
          zoomLock: true,
        }],
        xAxis: {
          type: "category",
          data: this.category,
          splitNumber: 6.5,
          axisLabel: {
            show: true,
            margin: 25,
            interval: 0,
            fontSize: 22,
            fontWeight: "bold",
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, 1)",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)",
            },
          },
          boundaryGap: true,
        },
        yAxis: {
          type: "value",
          name: "kwh",
          nameLocation: "end",
          nameGap: 25,
          nameTextStyle: {
            fontSize: 22,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .6)",
          },
          min: 0,
          max: this.max,
          minInterval: 1000,
          splitNumber: 5,
          axisLabel: {
            margin: 25,
            fontSize: 24,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .8)",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)",
            },
          },
        },
        series: [
          {
            z: 1,
            name: "充电站销量统计",
            type: "bar",
            barWidth: barWidth,
            data: this.data,
            itemStyle: {
              normal: {
                color: color,
              },
            },
            label: {
              show: false,
              position: "top",
              distance: 20,
              fontSize: 16,
              fontFamily: "screen",
              color: "#F89E85",
            },
            emphasis: {
              label: {
                fontSize: 18,
              },
            },
            animation: true,
          },
          {
            z: 2,
            name: "充电站销量统计",
            type: "pictorialBar",
            data: this.sectionData,
            symbol: "diamond",
            symbolOffset: [0, "50%"],
            symbolSize: [barWidth, 10],
            itemStyle: {
              normal: {
                color: color,
              },
            },
            animation: true,
          },
          {
            z: 3,
            name: "充电站销量统计",
            type: "pictorialBar",
            symbolPosition: "end",
            data: this.data,
            symbol: "diamond",
            symbolOffset: [0, "-56%"],
            symbolSize: [barWidth + 1, 10],
            itemStyle: {
              normal: {
                borderWidth: 2,
                color: colorArr[2],
              },
            },
            animation: true,
          },
        ],
      };

      this.chart.setOption(options);

      this.chart.dispatchAction({
        type: "dataZoom",
        startValue: this.data.length - 11,
        endValue: this.data.length,
      });
    },
    changeType(type) {
      this.type = type;
      let time = new Date();
      this.currentMonth = (time.getMonth() + 1) + "";
      this.getData();
    },
    changeYear(year) {
      this.currentYear = year;
      this.getData();
    },
    changeMonth(month) {
      this.currentMonth = month;
      this.getData();
    },
  },
};
</script>
<style scoped lang="scss">
.box-header-tab {
  display: flex;
  flex-direction: row;
  align-items: center;

  .tab-item {
    width: 166px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: url("../../assets/image/bg_tab_un.png");
    color: rgba(161, 197, 234, .7);
    font-size: 30px;
    line-height: 72px;
    font-family: "screen", serif;
    margin-right: 25px;
    cursor: pointer;

    &.active {
      color: #E7F3FF;
      text-shadow: 0 0 1em rgba(82, 163, 255, .56), 0 0 1em rgba(82, 163, 255, .56);
      background: url("../../assets/image/bg_tab_on.png");
    }
  }
}

.box-filter {
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 30px;;
  box-sizing: border-box;
}

.box-count {
  height: 50px;
  line-height: 45px;

  .count-name {
    font-size: 28px;
    color: rgb(181, 228, 255);
  }

  .count-value {
    font-size: 32px;
    color: rgb(86, 237, 255);
    font-family: "screen", serif;
  }

  .count-unit {
    font-size: 22px;
    color: rgba(181, 228, 255, 0.6);
    margin-left: 10px;
  }
}

.box-select {
  width: 200px;

  ::v-deep.el-input {
    font-size: 30px;

    .el-input__inner {
      height: 60px;
      line-height: 60px;
    }
  }
}
</style>
